import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const categoryService = {
  get: async (search = "", token) => {
    const response = await https.get(
      `${API_ROUTES.CATEGORY.GET_ALL}?search_value=${search}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
  // GET ALL
  get_all: async (page = 1, limit = 10, search = "", token) => {
    const response = await https.get(
      `${API_ROUTES.CATEGORY.GET_ALL}?page=${page}&limit=${limit}&search_value=${search}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },

  // GET BY ID
  get_by_id: async (category_id, token) => {
    const response = await https.get(
      `${API_ROUTES.CATEGORY.GET_BY_ID}/${category_id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },

  // CREATE
  create_category: async (data, token) => {
    /**
     * Data format:
     * {
     *   categoryName: "Category Name",
     *   description: "Category Description",
     *   image: "Image URL or Base64 String",
     *   createdAt: "Optional Timestamp"
     * }
     */
    const response = await https.post(API_ROUTES.CATEGORY.CREATE, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  },

  // UPDATE
  update_category: async (category_id, data, token) => {
    /**
     * Data format:
     * {
     *   categoryName: "Updated Category Name",
     *   description: "Updated Description",
     *   image: "Updated Image URL or Base64 String",
     * }
     */
    const response = await https.put(
      `${API_ROUTES.CATEGORY.UPDATE}/${category_id}`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },

  // DELETE
  delete_category: async (category_id, token) => {
    const response = await https.delete(
      `${API_ROUTES.CATEGORY.DELETE}/${category_id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
};
